import type { OutreachWireError } from '@discovr/types';

/** What the operator is told when Go sent a value this build does not know. Not "please refresh": the failure is
 *  deterministic, so only updating the app (or fixing the row) clears it. The message carries the field, value and row. */
export function wireErrorCopy(error: OutreachWireError): string {
  const what = error.field === 'by_state' || error.field === 'removed_or_rejected' ? 'the tab counts' : 'a creator row';
  return `This version of the app doesn't recognise ${what} the server sent, so it can't show it safely. Refreshing won't fix this; the app needs updating. (${error.message})`;
}
